import React from 'react'
import { useTranslation } from 'react-i18next'
import Fade from 'react-reveal/Fade'
import Flip from 'react-reveal/Flip'

const Championship = () => {
	const { t, i18n } = useTranslation()
	return (
		<section
			className='h-auto rounded-md bg-main-primary rounded-betish shadow-championship mb-10 px-4 py-8 container mx-auto'
			id='championship'
		>
			<div className='mt-0'>
				<div className='px-4'>
					<p className='text-base md:text-4xl font-extrabold text-dark'>
						{t('translation:championship:title')}
						<Flip right cascade>
							<span className='bg-main-secondary'>
								{t('translation:championship:title_underlined')}
							</span>
						</Flip>
					</p>
				</div>
				<div className='md:flex'>
					<div className='text-sm md:text-2xl px-4 mt-20 md:w-6/12'>
						<p className='text-dark'>
							{t('translation:championship:subtitle_start')}
							<span
								className={
									i18n.languages[0] !== 'zh'
										? 'text-main-secondary_variant bg-main-secondary text-3xl'
										: 'hidden'
								}
							>
								€500,000
							</span>
							{t('translation:championship:subtitle_end')}
						</p>
						<p className='text-sm md:text-base md:text-dark mt-2'>
							{t('translation:championship:description_start')}
							<span className='text-main-secondary_variant bg-main-secondary'>
								{t('translation:championship:description_middle')}
							</span>
							{t('translation:championship:description_end')}
						</p>
					</div>
					<div className='w-full md:w-6/12 px-4 md:mt-4'>
						<Fade right>
							<img
								alt='...'
								className='h-full w-full object-cover overflow-hidden rounded-betish'
								src='trophy.png'
							/>
						</Fade>
					</div>
				</div>
				{/* <div className='p-12'>
					<p className='text-xl font-bold text-main-secondary underline text-center'>
						JOIN NOW
					</p>
				</div> */}
			</div>
		</section>
	)
}

export default Championship
